import(/* webpackMode: "eager" */ "/opt/build/repo/components/Applicants/page.tsx")